
/* Primer load */
document.addEventListener('DOMContentLoaded', () => {
  console.log('pixelemos.js loaded ✅');
  replaceBarsForBRs();
  setPhoneRequired(); 
});

/* Shopify section reload (Be Yours / OS 2.0) */
document.addEventListener('shopify:section:load', () => {
  replaceBarsForBRs();
  setPhoneRequired();
});
function replaceBarsForBRs() {
  const selectors = [
    'h1',
    'h2',
    'h3',
    '.title',
    '.heading',
    '.section-title',
    '.banner__subheading'
  ];

  const titles = document.querySelectorAll(selectors.join(','));

  titles.forEach(el => {
    if (!el.textContent.includes('|')) return;
    if (el.classList.contains('js-bars-replaced')) return;

    const walker = document.createTreeWalker(
      el,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.includes('|')) {
        const parts = node.nodeValue.split('|');

        const fragment = document.createDocumentFragment();
        fragment.appendChild(document.createTextNode(parts[0].trim()));
        fragment.appendChild(document.createElement('br'));
        fragment.appendChild(document.createTextNode(parts.slice(1).join('|').trim()));

        node.parentNode.replaceChild(fragment, node);
        el.classList.add('js-bars-replaced');
        break;
      }
    }
  });
}
function setPhoneRequired() {
  const input = document.querySelector('input[type="tel"]');
  if (!input) return;

  input.setAttribute('required', 'required');
  input.classList.add('required');
}

